// extracted by mini-css-extract-plugin
export var emailBlockLink = "_la-0";